import React, { Fragment } from 'react';

import lodash from 'lodash';
import MultiSelect from 'components/common/MultiSelect/MultiSelect';
import { Spinner } from 'components/common/LoadingStatus/LoadingStatus';
import { formatDataForSelect, pluralize } from 'pages/studyOverview/utils/helperFunctions';
import { DismissButton } from 'components/common/DismissiblePanel';
import ActionRow from '../components/ActionRow';
import styles from './DocumentTypes.scss';
import { DismissibleHeader } from 'components/common/DismissiblePanel';
import LabelWithTooltip from 'components/common/Tooltip/LabelWithTooltip';

import {
    SelectedOptionList,
    SelectedOptionCard,
    SelectedOptionLabels,
    SelectedOptionAction,
    SelectedOptionLeftColumn,
    SelectedOptionRightColumn,
} from 'components/common/SelectedOptionList';


export default function DocumentTypes({
    isProcessing,
    availableDocumentTypes,
    documentTypes,
    onAssignRoleClicked,
    onRemoveDocumentType,
    setDocumentTypes,
    onCancel,
    onSave,
    hasStudyRoles,
    rolesToDocumentType,
    complion4FlagEnabled,
}) {
    const addDocumentType = (selectedOptions) => {
        const documentTypesToAdd = lodash.intersectionWith(
            availableDocumentTypes,
            selectedOptions,
            (a, o) => a.id == o.value
        );
        setDocumentTypes(state => documentTypesToAdd);
    };

    if (isProcessing) {
        return <Spinner actionLabel='Adding' itemName={'new expectations'} />;
    }
    return (
        <Fragment data-cy="DocumentTypes">
            <DismissibleHeader
                title='Add Expectations'
                message={`Select the necessary document types for the lifecycle stage that this ${complion4FlagEnabled ? 'binder' : 'study'} is in.`}
            />
            <div className={styles.documentTypeWrapper} data-cy="DocumentTypes-div">
                <div className={styles.documentTypes} data-cy="DocumentTypes-divs">
                    <LabelWithTooltip message='These document types are populated from the study type.'>
                        Select Document Types
                    </LabelWithTooltip>
                    <MultiSelect
                        onChanged={addDocumentType}
                        options={formatDataForSelect(availableDocumentTypes, 'displayName', 'id', 'type')}
                        selectedOptions={formatDataForSelect(documentTypes, 'displayName', 'id', 'type')}
                    />

                    <DocumentTypeList
                        documentTypes={documentTypes}
                        rolesToDocumentType={rolesToDocumentType}
                        onRemove={(option) => onRemoveDocumentType(option.id)}
                        hasStudyRoles={hasStudyRoles}
                        onAssignRoleClicked={onAssignRoleClicked}
                    />
                </div>
                <ActionRow
                    primaryActionLabel="Add Expectations"
                    onCancel={onCancel}
                    onPrimaryAction={onSave}
                    primaryActionDisabled={lodash.isEmpty(documentTypes)}
                />
            </div>
        </Fragment>
    );
}

export const DocumentTypeList = ({
    documentTypes,
    rolesToDocumentType,
    onRemove,
    onAssignRoleClicked,
    hasStudyRoles,
}) => {
    const getAssignedRolesLabel = (documentTypeId) => {
        const entry = rolesToDocumentType && rolesToDocumentType.find(
            roleToDocumentType => roleToDocumentType.documentTypeId == documentTypeId
        );
        if (!entry) {
            return null;
        }
        return entry.roles.length > 0
            && `Assigned to ${entry.roles.length} ${pluralize('Role', entry.roles.length)}`;
    };

    const renderCard = (option, index) => (
        <SelectedOptionCard key={index}>
            <SelectedOptionLeftColumn>
                <SelectedOptionLabels
                    withEllipsis
                    primaryLabel={option.displayName}
                    secondaryLabel={getAssignedRolesLabel(option.id)}
                />
            </SelectedOptionLeftColumn>
            <SelectedOptionRightColumn>
                {
                    hasStudyRoles && option.type === 'staff' &&
                    <SelectedOptionAction
                        className={styles.assignedRole}
                        onClick={() => onAssignRoleClicked({
                            documentTypeName: option.displayName,
                            documentTypeId: option.id,
                        })}
                    >
                        Assign Roles
                    </SelectedOptionAction>
                }
                <DismissButton onClick={() => onRemove(option)} />
            </SelectedOptionRightColumn>
        </SelectedOptionCard>
    );
    return (
        <SelectedOptionList>
            {
                documentTypes.map(renderCard)
            }
        </SelectedOptionList>
    );
};

